import React from 'react';
import { MainCard, StepItem } from 'components/CapitalRevamp';
import styles from '../StatusFastLoan.css';

function FastLoanStep() {
  return (
    <div className={styles['investment-step-wrapper']}>
      <MainCard
        border="blue"
        title="Bagaimana proses selanjutnya setelah pengajuan di Back Office?"
      >
        <div className={styles['step-wrapper']}>
          <StepItem
            color="blue"
            number={1}
            title="Data diterima oleh Moka"
            position="first"
          />
          <StepItem
            color="blue"
            number={2}
            title="Data dikirimkan sementara ke database Commonwealth Bank"
          />
          <StepItem
            color="blue"
            number={3}
            title="Pengguna menerima notifikasi melalui email"
          />
          <StepItem
            color="blue"
            number={4}
            title="Penyelesaian proses pinjaman melalui eKiosk"
          />
          <StepItem
            color="blue"
            number={5}
            title="Pencarian dana melalui rekening Commonwealth Bank"
            position="last"
          />
        </div>
      </MainCard>
    </div>
  );
}

export default FastLoanStep;
